import React, { useEffect, useState } from "react";
import Layout from "./Layout";
import { scrollFunction, scrollToTop,scrollToSection } from "./scroll.js"
import { Link } from "react-router-dom";

function PrivacyPolicy() {
  const [showButton, setShowButton] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setShowButton(scrollFunction());
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <Layout>
      {showButton && (
        <button id="myBtn" onClick={scrollToTop} style={{ display: "block" }}>
          <svg
            style={{ color: "#7cd959" }}
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            fill="currentColor"
            className="bi bi-arrow-up-circle-fill"
            viewBox="0 0 16 16"
          >
            <path
              d="M16 8A8 8 0 1 0 0 8a8 8 0 0 0 16 0zm-7.5 3.5a.5.5 0 0 1-1 0V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707V11.5z"
              fill="#4fe83b"
            ></path>
          </svg>
        </button>
      )}
      
      <div className="streamer_header">
        <h1>
          <b className="highlighted">Streamfog</b> PRIVACY POLICY
        </h1>
      </div>
      <div className="streamer_body">
        <div className="table_contents">
          <h2 className="highlighted">Table of Contents</h2>
          <div className="table-of-contents__item">
            <Link href="#" onClick={()=>scrollToSection('intro')}>
              1.Information we collect
            </Link>
          </div>
          <div className="table-of-contents__item">
            <Link href="#" onClick={()=>scrollToSection('terms')}>
              2.Further usage{" "}
            </Link>
          </div>
          <div className="table-of-contents__item">
            <Link href="#" onClick={()=>scrollToSection('other')}>
              3.Cookies
            </Link>
          </div>
          <div className="table-of-contents__item">
            <Link href="#" onClick={()=>scrollToSection('user')}>
              4.Security
            </Link>
          </div>

          <div className="table-of-contents__item">
            <Link href="#" onClick={()=>scrollToSection('services')}>
              5.Removal
            </Link>
          </div>
        </div>
        <div className="table_body">
          <div className="table_html">
            <div>
              <h2 id="intro" className="highlighted">
                Information we collect
              </h2>
              <p>
                No withewashing, no empty phrases - here's what we do with your
                data.
              </p>
              As of now we only store information that you submit as part of
              your application for our closed alpha program. Here's the list:
              <ul>
                <li>
                  <b>Contact data</b> - information we need to reach out to you
                </li>
                <ul>
                  <li>
                    <b>Discord-Tag</b>
                  </li>
                  <li>
                    <b>Email adress</b>
                  </li>
                </ul>
                <li>
                  <b>Twitch name</b> - to get to know you and also unlock your
                  access to our software.
                </li>
                <li>
                  <b>Message content</b> - giving you an opportunity to make
                  your application unique
                </li>
              </ul>
              That's it.
            </div>
            <div>
              <h2 id="terms" className="highlighted">
                Further usage
              </h2>

              <p>
                Since we are in early development we might analyze data to
                provide a better product and user experience.
              </p>
            </div>
            <div>
              <h2 id="other" className="highlighted">
                Cookies
              </h2>
              <p>
                {" "}
                We are using Google Analytics to get an understanding of our
                target audience and also improve your experience on our website.
                Cookies are of course optional
              </p>
            </div>
            <div>
              <h2 id="user" className="highlighted">
                Security
              </h2>
              <p>
                We are securing your information based on most recent and safe
                technologies to prevent unintentional access.
              </p>
            </div>
            <div>
              <h2 id="services" className="highlighted">
                Removal
              </h2>
              <p>
                Revoking and deleting your application is of course possible.
              </p>
              <p>
                Send <a href="mailto:kev@streamfog.com">us</a> an email from the
                adress the application was filed with.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default PrivacyPolicy;
